import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import Sidebar from './components/Sidebar';
import Home from './components/Home';
import BulkProductRegister from './components/BulkProductRegister';
import BulkProductOrderCsvRegister from './components/BulkProductOrderCsvRegister';
import BulkDBConversion from './components/BulkDBConversion';
import BulkCSVExport from './components/BulkCSVExport';
import CategoryRegister from './components/CategoryRegister';
import CategoryDBConversion from './components/CategoryDBConversion';
import CategoryCSVExport from './components/CategoryCSVExport';
import TranslationXlsxExport from './components/TranslationXlsxExport';
import TranslationXlsxUpdate from './components/TranslationXlsxUpdate';
import TranslationXlsxApply from './components/TranslationXlsxApply';
import ExportKoreanDataExcel from './components/ExportKoreanDataExcel';
import ConvertXlsxToKr from './components/ConvertXlsxToKr';
import LocalizeDatabase from './components/LocalizeDatabase';
import UpdateJPTableByCache from './components/UpdateJPTableByCache';
import ExportJPServerCsv from './components/ExportJPServerCsv';
import ImportJPServerCsv from './components/ImportJPServerCsv';
import CheckLocalizationUpdate from './components/CheckLocalizationUpdate';
import CheckKrDataUpdate from './components/CheckKrDataUpdate';
import ExportJPServerUploadCsv from './components/ExportJPServerUploadCsv';
import UpdateJPCSVTable from './components/UpdateJPCSVTable';

import './App.css';  // 스타일링을 위한 CSS 파일 추가

function App() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  return (
    <Provider store={store}>
      <Router>
        <div className="app">
          {!isSidebarVisible && (
            <button className="menu-button" onClick={toggleSidebar}>
              <span>☰</span>
              <span>메뉴</span>
            </button>
          )}
          <Sidebar isVisible={isSidebarVisible} toggleSidebar={toggleSidebar} />
          <div className={`content ${isSidebarVisible ? 'shifted' : ''}`}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path='/bulk-product-export' element={<ExportKoreanDataExcel />} />
              <Route path="/bulk-product-register" element={<BulkProductRegister />} />
              <Route path="/bulk-product-order-register" element={<BulkProductOrderCsvRegister />} />
              <Route path="/convert-xlsx-to-kr" element={<ConvertXlsxToKr />} />
              <Route path="/bulk-db-conversion" element={<BulkDBConversion />} />
              <Route path="/bulk-csv-export" element={<BulkCSVExport />} />
              <Route path="/category-register" element={<CategoryRegister />} />
              <Route path="/category-db-conversion" element={<CategoryDBConversion />} />
              <Route path="/category-csv-export" element={<CategoryCSVExport />} />
              <Route path="/translation-xlsx-export" element={<TranslationXlsxExport />} />
              <Route path="/translation-xlsx-update" element={<TranslationXlsxUpdate />} />
              <Route path="/translation-xlsx-apply" element={<TranslationXlsxApply />} />
              <Route path="/localize-database" element={<LocalizeDatabase />} />
              <Route path="/update-table-by-cache" element={<UpdateJPTableByCache />} />
              <Route path="/jp-server-csv-download" element={<ExportJPServerCsv />} />
              <Route path="/jp-server-csv-upload" element={<ImportJPServerCsv />} />
              <Route path="/check-localization-update" element={<CheckLocalizationUpdate />} />
              <Route path="/check-krdata-update" element={<CheckKrDataUpdate />} />
              <Route path="/export-jp-server-upload-csv" element={<ExportJPServerUploadCsv />} />
              <Route path="/update-jp-server-upload-table" element={<UpdateJPCSVTable />} />
            </Routes>
          </div>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
